import { render, staticRenderFns } from "./Sea.vue?vue&type=template&id=02954384&"
import script from "./Sea.vue?vue&type=script&lang=js&"
export * from "./Sea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports